import Swiper, { Navigation, Autoplay } from 'swiper'

export const pageHero = () => {
  const slides = Array.from(document.querySelectorAll('.page-hero'))
  
  if(slides.length > 1){
    const swiper = new Swiper('.swiper-page-hero', {
      modules: [Navigation, Autoplay],
      navigation: {
        nextEl: '.page-hero-next',
        prevEl: '.page-hero-prev',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      slidesPerView: '1',
      loop: true
    })
  
    slides.forEach((slide) => {
      const video = slide.querySelector('video')
      const pause = slide.querySelector('.pause')
      const play = slide.querySelector('.play')
  
      if (video){      
        pause.addEventListener('click', () => {
          pause.classList.remove('show')
          play.classList.add('show')
          video.pause()
        })
  
        play.addEventListener('click', () => {
          pause.classList.add('show')
          play.classList.remove('show')
          video.play()
        })
      }
    })
  }
  
}
